import React, { forwardRef } from "react";
export default forwardRef(function TextArea(
  { value, onChange, placeholder, onFocus, onBlur },
  ref
) {
  return (
    <textarea
      ref={ref}
      name="postContent"
      value={value}
      onChange={onChange}
      onFocus={onFocus}
      onBlur={onBlur}
      placeholder={placeholder}
      rows={10}
      cols={40}
      className="bg-[#f6f6f6]
        w-full
        h-[200px]
        lg:text-[42px]
        md:text-[32px]
        text-[20px]
        p-6
        rounded-xl
        text-textgray
        font-medium
        font-outfit
        placeholder-gray-500
        resize-none
        focus:outline-none
        focus:ring-2
        focus:ring-gray-300"
    />


  );
});